/** The product tour route — shared by the client routes and backend email links. */
export const TOUR_PATH = '/tour';

/** The onboarding wizard route — shared by the client routes and backend email links. */
export const ONBOARDING_SETUP_PATH = '/onboarding/setup';
